import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const awardDetailsContainer = style({
  borderRadius: borderRadius.r16,
  backgroundColor: themeVars.container.secondary.background.idle,
  textDecoration: 'none',
  padding: space.s12,
  margin: `${space.s3}px 0`,
  display: 'flex',
  flexDirection: 'column',
  gap: space.s5,
});

export const header = style({
  ...typography['labelSm'],

  color: themeVars.container.foreground.primary,
  display: 'flex',
  justifyContent: 'space-between',
});

export const title = style({});

export const tournamentIdentifier = style({
  ...typography['bodySm'],

  textDecoration: 'underline',
});
